import { createContext, useContext, useState, useCallback, ReactNode } from "react";

type CheckoutState = "closed" | "opening" | "form" | "processing" | "granted";

interface CheckoutContextType {
  state: CheckoutState;
  openCheckout: () => void;
  closeCheckout: () => void;
  setCheckoutState: (s: CheckoutState) => void;
}

const CheckoutContext = createContext<CheckoutContextType | null>(null);

export const useCheckout = () => {
  const ctx = useContext(CheckoutContext);
  if (!ctx) throw new Error("useCheckout must be inside CheckoutProvider");
  return ctx;
};

export const CheckoutProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<CheckoutState>("closed");

  const openCheckout = useCallback(() => {
    setState("opening");
    setTimeout(() => setState("form"), 700);
  }, []);

  const closeCheckout = useCallback(() => setState("closed"), []);

  return (
    <CheckoutContext.Provider value={{ state, openCheckout, closeCheckout, setCheckoutState: setState }}>
      {children}
    </CheckoutContext.Provider>
  );
};
